import { Box } from '@mui/material'

/**
 * Component wrapper trang của hệ thống
 * @param {*} param0 
 * @returns 
 */
const ContainerPage = ({children, sx = { flex: 1}, ...props}) => {
    return (
        <Box sx={sx} {...props}>
            {children}
        </Box>
    )
}

export default ContainerPage